// GERADO AUTOMATICAMENTE por scripts/set-version.js (npm prebuild).
// Não editar à mão — o valor é sobrescrito a cada build.
// Fora da Vercel (sem VERCEL_GIT_COMMIT_SHA) o valor é "dev", e nesse
// caso o aviso de nova versão fica desligado.
export const APP_VERSION = "2f74d86d3326054ee2ef758292d565cd6d7bef13";
